// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v5.29.3
// source: action.proto
/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Lab_LabInfo } from "./lab";
import { Player_CreateWex, Player_WexGetProperties, Player_WexPlayLive, Player_WexPlayPause, Player_WexPlayRecording, Player_WexPlayVod, Player_WexSeek, Player_WexSetAudioTrack, } from "./player";
import { PlayerOutput_AdBreakData, PlayerOutput_AdBreakSkipAvailable, PlayerOutput_AdBreakSkipUnavailable, PlayerOutput_AdData, PlayerOutput_AdErrorData, PlayerOutput_AdMetadataData, PlayerOutput_AdPositionChangedData, PlayerOutput_AdTimeData, PlayerOutput_AvailableAudioTracks, PlayerOutput_AvailableAudioTracksChanged, PlayerOutput_AvailableSubtitlesTrackChanged, PlayerOutput_AvailableSubtitlesTracks, PlayerOutput_CastMediaTracksChanged, PlayerOutput_CastMediaTrackSelectionChanged, PlayerOutput_CurrentPositionChanged, PlayerOutput_LatencyMetadata, PlayerOutput_MediaChanged, PlayerOutput_MediaEnded, PlayerOutput_PauseAdData, PlayerOutput_PlaybackStateChanged, PlayerOutput_PlayerError, PlayerOutput_PlayerReady, PlayerOutput_PlayerStateChanged, PlayerOutput_Properties, PlayerOutput_QualityChanged, PlayerOutput_Seeked, PlayerOutput_SeekResult, PlayerOutput_SelectedAudioTrack, PlayerOutput_SelectedAudioTrackChanged, PlayerOutput_SelectedSubtitlesTrack, PlayerOutput_SelectedSubtitlesTrackChanged, PlayerOutput_ThumbnailData, PlayerOutput_WatchReceived, PlayerOutput_WatchRequested, } from "./player_output";
import { Sdk_Action } from "./sdk";
import { SdkZapi_Action } from "./sdk_zapi";
import { TafAction } from "./taf_action";
import { Wex_PlayerOutput_Properties } from "./wex";
import { ZapiAction } from "./zapi";
export const protobufPackage = "taf";
export var Output_Log_Source;
(function (Output_Log_Source) {
    Output_Log_Source[Output_Log_Source["TAF"] = 0] = "TAF";
    Output_Log_Source[Output_Log_Source["PLAYER"] = 1] = "PLAYER";
    Output_Log_Source[Output_Log_Source["PLAYER_ADAPTER"] = 2] = "PLAYER_ADAPTER";
    Output_Log_Source[Output_Log_Source["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Output_Log_Source || (Output_Log_Source = {}));
export function output_Log_SourceFromJSON(object) {
    switch (object) {
        case 0:
        case "TAF":
            return Output_Log_Source.TAF;
        case 1:
        case "PLAYER":
            return Output_Log_Source.PLAYER;
        case 2:
        case "PLAYER_ADAPTER":
            return Output_Log_Source.PLAYER_ADAPTER;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Output_Log_Source.UNRECOGNIZED;
    }
}
export function output_Log_SourceToJSON(object) {
    switch (object) {
        case Output_Log_Source.TAF:
            return "TAF";
        case Output_Log_Source.PLAYER:
            return "PLAYER";
        case Output_Log_Source.PLAYER_ADAPTER:
            return "PLAYER_ADAPTER";
        case Output_Log_Source.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
export var Output_Log_Level;
(function (Output_Log_Level) {
    Output_Log_Level[Output_Log_Level["DEBUG"] = 0] = "DEBUG";
    Output_Log_Level[Output_Log_Level["INFO"] = 1] = "INFO";
    Output_Log_Level[Output_Log_Level["WARN"] = 2] = "WARN";
    Output_Log_Level[Output_Log_Level["ERROR"] = 3] = "ERROR";
    Output_Log_Level[Output_Log_Level["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Output_Log_Level || (Output_Log_Level = {}));
export function output_Log_LevelFromJSON(object) {
    switch (object) {
        case 0:
        case "DEBUG":
            return Output_Log_Level.DEBUG;
        case 1:
        case "INFO":
            return Output_Log_Level.INFO;
        case 2:
        case "WARN":
            return Output_Log_Level.WARN;
        case 3:
        case "ERROR":
            return Output_Log_Level.ERROR;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Output_Log_Level.UNRECOGNIZED;
    }
}
export function output_Log_LevelToJSON(object) {
    switch (object) {
        case Output_Log_Level.DEBUG:
            return "DEBUG";
        case Output_Log_Level.INFO:
            return "INFO";
        case Output_Log_Level.WARN:
            return "WARN";
        case Output_Log_Level.ERROR:
            return "ERROR";
        case Output_Log_Level.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseAction() {
    return {
        id: "",
        session: undefined,
        taf: undefined,
        zapi: undefined,
        sdk: undefined,
        sdkZapi: undefined,
        playerCreateWex: undefined,
        playerWexGetProperties: undefined,
        playerWexPlayLive: undefined,
        playerWexPlayVod: undefined,
        playerWexPlayRecording: undefined,
        playerWexSetAudioTrack: undefined,
        playerWexPlayPause: undefined,
        playerWexSeek: undefined,
    };
}
export const Action = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.session !== undefined) {
            Action_Session.encode(message.session, writer.uint32(18).fork()).ldelim();
        }
        if (message.taf !== undefined) {
            TafAction.encode(message.taf, writer.uint32(26).fork()).ldelim();
        }
        if (message.zapi !== undefined) {
            ZapiAction.encode(message.zapi, writer.uint32(34).fork()).ldelim();
        }
        if (message.sdk !== undefined) {
            Sdk_Action.encode(message.sdk, writer.uint32(42).fork()).ldelim();
        }
        if (message.sdkZapi !== undefined) {
            SdkZapi_Action.encode(message.sdkZapi, writer.uint32(50).fork()).ldelim();
        }
        if (message.playerCreateWex !== undefined) {
            Player_CreateWex.encode(message.playerCreateWex, writer.uint32(9602).fork()).ldelim();
        }
        if (message.playerWexGetProperties !== undefined) {
            Player_WexGetProperties.encode(message.playerWexGetProperties, writer.uint32(9610).fork()).ldelim();
        }
        if (message.playerWexPlayLive !== undefined) {
            Player_WexPlayLive.encode(message.playerWexPlayLive, writer.uint32(9618).fork()).ldelim();
        }
        if (message.playerWexPlayVod !== undefined) {
            Player_WexPlayVod.encode(message.playerWexPlayVod, writer.uint32(9626).fork()).ldelim();
        }
        if (message.playerWexPlayRecording !== undefined) {
            Player_WexPlayRecording.encode(message.playerWexPlayRecording, writer.uint32(9634).fork()).ldelim();
        }
        if (message.playerWexSetAudioTrack !== undefined) {
            Player_WexSetAudioTrack.encode(message.playerWexSetAudioTrack, writer.uint32(9642).fork()).ldelim();
        }
        if (message.playerWexPlayPause !== undefined) {
            Player_WexPlayPause.encode(message.playerWexPlayPause, writer.uint32(9650).fork()).ldelim();
        }
        if (message.playerWexSeek !== undefined) {
            Player_WexSeek.encode(message.playerWexSeek, writer.uint32(9658).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.session = Action_Session.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.taf = TafAction.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.zapi = ZapiAction.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.sdk = Sdk_Action.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.sdkZapi = SdkZapi_Action.decode(reader, reader.uint32());
                    continue;
                case 1200:
                    if (tag !== 9602) {
                        break;
                    }
                    message.playerCreateWex = Player_CreateWex.decode(reader, reader.uint32());
                    continue;
                case 1201:
                    if (tag !== 9610) {
                        break;
                    }
                    message.playerWexGetProperties = Player_WexGetProperties.decode(reader, reader.uint32());
                    continue;
                case 1202:
                    if (tag !== 9618) {
                        break;
                    }
                    message.playerWexPlayLive = Player_WexPlayLive.decode(reader, reader.uint32());
                    continue;
                case 1203:
                    if (tag !== 9626) {
                        break;
                    }
                    message.playerWexPlayVod = Player_WexPlayVod.decode(reader, reader.uint32());
                    continue;
                case 1204:
                    if (tag !== 9634) {
                        break;
                    }
                    message.playerWexPlayRecording = Player_WexPlayRecording.decode(reader, reader.uint32());
                    continue;
                case 1205:
                    if (tag !== 9642) {
                        break;
                    }
                    message.playerWexSetAudioTrack = Player_WexSetAudioTrack.decode(reader, reader.uint32());
                    continue;
                case 1206:
                    if (tag !== 9650) {
                        break;
                    }
                    message.playerWexPlayPause = Player_WexPlayPause.decode(reader, reader.uint32());
                    continue;
                case 1207:
                    if (tag !== 9658) {
                        break;
                    }
                    message.playerWexSeek = Player_WexSeek.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            session: isSet(object.session) ? Action_Session.fromJSON(object.session) : undefined,
            taf: isSet(object.taf) ? TafAction.fromJSON(object.taf) : undefined,
            zapi: isSet(object.zapi) ? ZapiAction.fromJSON(object.zapi) : undefined,
            sdk: isSet(object.sdk) ? Sdk_Action.fromJSON(object.sdk) : undefined,
            sdkZapi: isSet(object.sdkZapi) ? SdkZapi_Action.fromJSON(object.sdkZapi) : undefined,
            playerCreateWex: isSet(object.playerCreateWex) ? Player_CreateWex.fromJSON(object.playerCreateWex) : undefined,
            playerWexGetProperties: isSet(object.playerWexGetProperties)
                ? Player_WexGetProperties.fromJSON(object.playerWexGetProperties)
                : undefined,
            playerWexPlayLive: isSet(object.playerWexPlayLive)
                ? Player_WexPlayLive.fromJSON(object.playerWexPlayLive)
                : undefined,
            playerWexPlayVod: isSet(object.playerWexPlayVod)
                ? Player_WexPlayVod.fromJSON(object.playerWexPlayVod)
                : undefined,
            playerWexPlayRecording: isSet(object.playerWexPlayRecording)
                ? Player_WexPlayRecording.fromJSON(object.playerWexPlayRecording)
                : undefined,
            playerWexSetAudioTrack: isSet(object.playerWexSetAudioTrack)
                ? Player_WexSetAudioTrack.fromJSON(object.playerWexSetAudioTrack)
                : undefined,
            playerWexPlayPause: isSet(object.playerWexPlayPause)
                ? Player_WexPlayPause.fromJSON(object.playerWexPlayPause)
                : undefined,
            playerWexSeek: isSet(object.playerWexSeek) ? Player_WexSeek.fromJSON(object.playerWexSeek) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.session !== undefined) {
            obj.session = Action_Session.toJSON(message.session);
        }
        if (message.taf !== undefined) {
            obj.taf = TafAction.toJSON(message.taf);
        }
        if (message.zapi !== undefined) {
            obj.zapi = ZapiAction.toJSON(message.zapi);
        }
        if (message.sdk !== undefined) {
            obj.sdk = Sdk_Action.toJSON(message.sdk);
        }
        if (message.sdkZapi !== undefined) {
            obj.sdkZapi = SdkZapi_Action.toJSON(message.sdkZapi);
        }
        if (message.playerCreateWex !== undefined) {
            obj.playerCreateWex = Player_CreateWex.toJSON(message.playerCreateWex);
        }
        if (message.playerWexGetProperties !== undefined) {
            obj.playerWexGetProperties = Player_WexGetProperties.toJSON(message.playerWexGetProperties);
        }
        if (message.playerWexPlayLive !== undefined) {
            obj.playerWexPlayLive = Player_WexPlayLive.toJSON(message.playerWexPlayLive);
        }
        if (message.playerWexPlayVod !== undefined) {
            obj.playerWexPlayVod = Player_WexPlayVod.toJSON(message.playerWexPlayVod);
        }
        if (message.playerWexPlayRecording !== undefined) {
            obj.playerWexPlayRecording = Player_WexPlayRecording.toJSON(message.playerWexPlayRecording);
        }
        if (message.playerWexSetAudioTrack !== undefined) {
            obj.playerWexSetAudioTrack = Player_WexSetAudioTrack.toJSON(message.playerWexSetAudioTrack);
        }
        if (message.playerWexPlayPause !== undefined) {
            obj.playerWexPlayPause = Player_WexPlayPause.toJSON(message.playerWexPlayPause);
        }
        if (message.playerWexSeek !== undefined) {
            obj.playerWexSeek = Player_WexSeek.toJSON(message.playerWexSeek);
        }
        return obj;
    },
    create(base) {
        return Action.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAction();
        message.id = object.id ?? "";
        message.session = (object.session !== undefined && object.session !== null)
            ? Action_Session.fromPartial(object.session)
            : undefined;
        message.taf = (object.taf !== undefined && object.taf !== null) ? TafAction.fromPartial(object.taf) : undefined;
        message.zapi = (object.zapi !== undefined && object.zapi !== null)
            ? ZapiAction.fromPartial(object.zapi)
            : undefined;
        message.sdk = (object.sdk !== undefined && object.sdk !== null) ? Sdk_Action.fromPartial(object.sdk) : undefined;
        message.sdkZapi = (object.sdkZapi !== undefined && object.sdkZapi !== null)
            ? SdkZapi_Action.fromPartial(object.sdkZapi)
            : undefined;
        message.playerCreateWex = (object.playerCreateWex !== undefined && object.playerCreateWex !== null)
            ? Player_CreateWex.fromPartial(object.playerCreateWex)
            : undefined;
        message.playerWexGetProperties =
            (object.playerWexGetProperties !== undefined && object.playerWexGetProperties !== null)
                ? Player_WexGetProperties.fromPartial(object.playerWexGetProperties)
                : undefined;
        message.playerWexPlayLive = (object.playerWexPlayLive !== undefined && object.playerWexPlayLive !== null)
            ? Player_WexPlayLive.fromPartial(object.playerWexPlayLive)
            : undefined;
        message.playerWexPlayVod = (object.playerWexPlayVod !== undefined && object.playerWexPlayVod !== null)
            ? Player_WexPlayVod.fromPartial(object.playerWexPlayVod)
            : undefined;
        message.playerWexPlayRecording =
            (object.playerWexPlayRecording !== undefined && object.playerWexPlayRecording !== null)
                ? Player_WexPlayRecording.fromPartial(object.playerWexPlayRecording)
                : undefined;
        message.playerWexSetAudioTrack =
            (object.playerWexSetAudioTrack !== undefined && object.playerWexSetAudioTrack !== null)
                ? Player_WexSetAudioTrack.fromPartial(object.playerWexSetAudioTrack)
                : undefined;
        message.playerWexPlayPause = (object.playerWexPlayPause !== undefined && object.playerWexPlayPause !== null)
            ? Player_WexPlayPause.fromPartial(object.playerWexPlayPause)
            : undefined;
        message.playerWexSeek = (object.playerWexSeek !== undefined && object.playerWexSeek !== null)
            ? Player_WexSeek.fromPartial(object.playerWexSeek)
            : undefined;
        return message;
    },
};
function createBaseAction_Session() {
    return { sessionId: "" };
}
export const Action_Session = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.sessionId !== "") {
            writer.uint32(10).string(message.sessionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAction_Session();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.sessionId = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { sessionId: isSet(object.sessionId) ? globalThis.String(object.sessionId) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.sessionId !== "") {
            obj.sessionId = message.sessionId;
        }
        return obj;
    },
    create(base) {
        return Action_Session.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAction_Session();
        message.sessionId = object.sessionId ?? "";
        return message;
    },
};
function createBaseOutput() {
    return {
        deviceInfo: undefined,
        tafSessions: undefined,
        playerEvent: undefined,
        actionResult: undefined,
        tafLabs: undefined,
        log: undefined,
        tafInfo: undefined,
    };
}
export const Output = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.deviceInfo !== undefined) {
            Output_DeviceInfo.encode(message.deviceInfo, writer.uint32(10).fork()).ldelim();
        }
        if (message.tafSessions !== undefined) {
            Output_TafSessions.encode(message.tafSessions, writer.uint32(18).fork()).ldelim();
        }
        if (message.playerEvent !== undefined) {
            Output_PlayerEvent.encode(message.playerEvent, writer.uint32(26).fork()).ldelim();
        }
        if (message.actionResult !== undefined) {
            Output_ActionResult.encode(message.actionResult, writer.uint32(34).fork()).ldelim();
        }
        if (message.tafLabs !== undefined) {
            Output_TafLabs.encode(message.tafLabs, writer.uint32(42).fork()).ldelim();
        }
        if (message.log !== undefined) {
            Output_Log.encode(message.log, writer.uint32(50).fork()).ldelim();
        }
        if (message.tafInfo !== undefined) {
            Output_TafInfo.encode(message.tafInfo, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOutput();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.deviceInfo = Output_DeviceInfo.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.tafSessions = Output_TafSessions.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.playerEvent = Output_PlayerEvent.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.actionResult = Output_ActionResult.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.tafLabs = Output_TafLabs.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.log = Output_Log.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.tafInfo = Output_TafInfo.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            deviceInfo: isSet(object.deviceInfo) ? Output_DeviceInfo.fromJSON(object.deviceInfo) : undefined,
            tafSessions: isSet(object.tafSessions) ? Output_TafSessions.fromJSON(object.tafSessions) : undefined,
            playerEvent: isSet(object.playerEvent) ? Output_PlayerEvent.fromJSON(object.playerEvent) : undefined,
            actionResult: isSet(object.actionResult) ? Output_ActionResult.fromJSON(object.actionResult) : undefined,
            tafLabs: isSet(object.tafLabs) ? Output_TafLabs.fromJSON(object.tafLabs) : undefined,
            log: isSet(object.log) ? Output_Log.fromJSON(object.log) : undefined,
            tafInfo: isSet(object.tafInfo) ? Output_TafInfo.fromJSON(object.tafInfo) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.deviceInfo !== undefined) {
            obj.deviceInfo = Output_DeviceInfo.toJSON(message.deviceInfo);
        }
        if (message.tafSessions !== undefined) {
            obj.tafSessions = Output_TafSessions.toJSON(message.tafSessions);
        }
        if (message.playerEvent !== undefined) {
            obj.playerEvent = Output_PlayerEvent.toJSON(message.playerEvent);
        }
        if (message.actionResult !== undefined) {
            obj.actionResult = Output_ActionResult.toJSON(message.actionResult);
        }
        if (message.tafLabs !== undefined) {
            obj.tafLabs = Output_TafLabs.toJSON(message.tafLabs);
        }
        if (message.log !== undefined) {
            obj.log = Output_Log.toJSON(message.log);
        }
        if (message.tafInfo !== undefined) {
            obj.tafInfo = Output_TafInfo.toJSON(message.tafInfo);
        }
        return obj;
    },
    create(base) {
        return Output.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOutput();
        message.deviceInfo = (object.deviceInfo !== undefined && object.deviceInfo !== null)
            ? Output_DeviceInfo.fromPartial(object.deviceInfo)
            : undefined;
        message.tafSessions = (object.tafSessions !== undefined && object.tafSessions !== null)
            ? Output_TafSessions.fromPartial(object.tafSessions)
            : undefined;
        message.playerEvent = (object.playerEvent !== undefined && object.playerEvent !== null)
            ? Output_PlayerEvent.fromPartial(object.playerEvent)
            : undefined;
        message.actionResult = (object.actionResult !== undefined && object.actionResult !== null)
            ? Output_ActionResult.fromPartial(object.actionResult)
            : undefined;
        message.tafLabs = (object.tafLabs !== undefined && object.tafLabs !== null)
            ? Output_TafLabs.fromPartial(object.tafLabs)
            : undefined;
        message.log = (object.log !== undefined && object.log !== null) ? Output_Log.fromPartial(object.log) : undefined;
        message.tafInfo = (object.tafInfo !== undefined && object.tafInfo !== null)
            ? Output_TafInfo.fromPartial(object.tafInfo)
            : undefined;
        return message;
    },
};
function createBaseOutput_DeviceInfo() {
    return { name: "", id: "", platform: "" };
}
export const Output_DeviceInfo = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.id !== "") {
            writer.uint32(18).string(message.id);
        }
        if (message.platform !== "") {
            writer.uint32(26).string(message.platform);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOutput_DeviceInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.platform = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            platform: isSet(object.platform) ? globalThis.String(object.platform) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.platform !== "") {
            obj.platform = message.platform;
        }
        return obj;
    },
    create(base) {
        return Output_DeviceInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOutput_DeviceInfo();
        message.name = object.name ?? "";
        message.id = object.id ?? "";
        message.platform = object.platform ?? "";
        return message;
    },
};
function createBaseOutput_SessionInfo() {
    return { name: "", id: "", platform: "", ip: "", ready: false };
}
export const Output_SessionInfo = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.id !== "") {
            writer.uint32(18).string(message.id);
        }
        if (message.platform !== "") {
            writer.uint32(26).string(message.platform);
        }
        if (message.ip !== "") {
            writer.uint32(34).string(message.ip);
        }
        if (message.ready !== false) {
            writer.uint32(40).bool(message.ready);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOutput_SessionInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.platform = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.ip = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.ready = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            platform: isSet(object.platform) ? globalThis.String(object.platform) : "",
            ip: isSet(object.ip) ? globalThis.String(object.ip) : "",
            ready: isSet(object.ready) ? globalThis.Boolean(object.ready) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.platform !== "") {
            obj.platform = message.platform;
        }
        if (message.ip !== "") {
            obj.ip = message.ip;
        }
        if (message.ready !== false) {
            obj.ready = message.ready;
        }
        return obj;
    },
    create(base) {
        return Output_SessionInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOutput_SessionInfo();
        message.name = object.name ?? "";
        message.id = object.id ?? "";
        message.platform = object.platform ?? "";
        message.ip = object.ip ?? "";
        message.ready = object.ready ?? false;
        return message;
    },
};
function createBaseOutput_TafInfo() {
    return { apiUrl: "" };
}
export const Output_TafInfo = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.apiUrl !== "") {
            writer.uint32(10).string(message.apiUrl);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOutput_TafInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.apiUrl = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { apiUrl: isSet(object.apiUrl) ? globalThis.String(object.apiUrl) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.apiUrl !== "") {
            obj.apiUrl = message.apiUrl;
        }
        return obj;
    },
    create(base) {
        return Output_TafInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOutput_TafInfo();
        message.apiUrl = object.apiUrl ?? "";
        return message;
    },
};
function createBaseOutput_TafSessions() {
    return { sessions: [] };
}
export const Output_TafSessions = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.sessions) {
            Output_SessionInfo.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOutput_TafSessions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.sessions.push(Output_SessionInfo.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            sessions: globalThis.Array.isArray(object?.sessions)
                ? object.sessions.map((e) => Output_SessionInfo.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.sessions?.length) {
            obj.sessions = message.sessions.map((e) => Output_SessionInfo.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return Output_TafSessions.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOutput_TafSessions();
        message.sessions = object.sessions?.map((e) => Output_SessionInfo.fromPartial(e)) || [];
        return message;
    },
};
function createBaseOutput_TafLabs() {
    return { labInfo: [] };
}
export const Output_TafLabs = {
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.labInfo) {
            Lab_LabInfo.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOutput_TafLabs();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.labInfo.push(Lab_LabInfo.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            labInfo: globalThis.Array.isArray(object?.labInfo) ? object.labInfo.map((e) => Lab_LabInfo.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.labInfo?.length) {
            obj.labInfo = message.labInfo.map((e) => Lab_LabInfo.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return Output_TafLabs.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOutput_TafLabs();
        message.labInfo = object.labInfo?.map((e) => Lab_LabInfo.fromPartial(e)) || [];
        return message;
    },
};
function createBaseOutput_Log() {
    return { source: 0, level: 0, message: [] };
}
export const Output_Log = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.source !== 0) {
            writer.uint32(8).int32(message.source);
        }
        if (message.level !== 0) {
            writer.uint32(16).int32(message.level);
        }
        for (const v of message.message) {
            writer.uint32(26).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOutput_Log();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.source = reader.int32();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.level = reader.int32();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.message.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            source: isSet(object.source) ? output_Log_SourceFromJSON(object.source) : 0,
            level: isSet(object.level) ? output_Log_LevelFromJSON(object.level) : 0,
            message: globalThis.Array.isArray(object?.message) ? object.message.map((e) => globalThis.String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.source !== 0) {
            obj.source = output_Log_SourceToJSON(message.source);
        }
        if (message.level !== 0) {
            obj.level = output_Log_LevelToJSON(message.level);
        }
        if (message.message?.length) {
            obj.message = message.message;
        }
        return obj;
    },
    create(base) {
        return Output_Log.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOutput_Log();
        message.source = object.source ?? 0;
        message.level = object.level ?? 0;
        message.message = object.message?.map((e) => e) || [];
        return message;
    },
};
function createBaseOutput_PlayerEvent() {
    return {
        watchRequested: undefined,
        watchReceived: undefined,
        playerReady: undefined,
        mediaChanged: undefined,
        currentPositionChanged: undefined,
        seeked: undefined,
        playbackStateChanged: undefined,
        playerStateChanged: undefined,
        availableAudioTracksChanged: undefined,
        selectedAudioTrackChanged: undefined,
        availableSubtitlesTrackChanged: undefined,
        selectedSubtitlesTrackChanged: undefined,
        castMediaTrackSelectionChanged: undefined,
        castMediaTrackChanged: undefined,
        qualityChanged: undefined,
        playerError: undefined,
        wexOnEvent: undefined,
        latencyChanged: undefined,
        mediaEnded: undefined,
        adBreakStarted: undefined,
        adBreakEnded: undefined,
        adMetadata: undefined,
        adLoaded: undefined,
        adStarted: undefined,
        adPaused: undefined,
        adPositionChanged: undefined,
        adFirstQuartile: undefined,
        adMidpoint: undefined,
        adThirdQuartile: undefined,
        adEnded: undefined,
        adSkipped: undefined,
        adError: undefined,
        adResumed: undefined,
        adBreakSkipAvailable: undefined,
        adBreakSkipUnavailable: undefined,
        pauseAdParsed: undefined,
    };
}
export const Output_PlayerEvent = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.watchRequested !== undefined) {
            PlayerOutput_WatchRequested.encode(message.watchRequested, writer.uint32(74).fork()).ldelim();
        }
        if (message.watchReceived !== undefined) {
            PlayerOutput_WatchReceived.encode(message.watchReceived, writer.uint32(82).fork()).ldelim();
        }
        if (message.playerReady !== undefined) {
            PlayerOutput_PlayerReady.encode(message.playerReady, writer.uint32(90).fork()).ldelim();
        }
        if (message.mediaChanged !== undefined) {
            PlayerOutput_MediaChanged.encode(message.mediaChanged, writer.uint32(98).fork()).ldelim();
        }
        if (message.currentPositionChanged !== undefined) {
            PlayerOutput_CurrentPositionChanged.encode(message.currentPositionChanged, writer.uint32(106).fork()).ldelim();
        }
        if (message.seeked !== undefined) {
            PlayerOutput_Seeked.encode(message.seeked, writer.uint32(114).fork()).ldelim();
        }
        if (message.playbackStateChanged !== undefined) {
            PlayerOutput_PlaybackStateChanged.encode(message.playbackStateChanged, writer.uint32(10).fork()).ldelim();
        }
        if (message.playerStateChanged !== undefined) {
            PlayerOutput_PlayerStateChanged.encode(message.playerStateChanged, writer.uint32(122).fork()).ldelim();
        }
        if (message.availableAudioTracksChanged !== undefined) {
            PlayerOutput_AvailableAudioTracksChanged.encode(message.availableAudioTracksChanged, writer.uint32(42).fork())
                .ldelim();
        }
        if (message.selectedAudioTrackChanged !== undefined) {
            PlayerOutput_SelectedAudioTrackChanged.encode(message.selectedAudioTrackChanged, writer.uint32(50).fork())
                .ldelim();
        }
        if (message.availableSubtitlesTrackChanged !== undefined) {
            PlayerOutput_AvailableSubtitlesTrackChanged.encode(message.availableSubtitlesTrackChanged, writer.uint32(58).fork()).ldelim();
        }
        if (message.selectedSubtitlesTrackChanged !== undefined) {
            PlayerOutput_SelectedSubtitlesTrackChanged.encode(message.selectedSubtitlesTrackChanged, writer.uint32(66).fork())
                .ldelim();
        }
        if (message.castMediaTrackSelectionChanged !== undefined) {
            PlayerOutput_CastMediaTrackSelectionChanged.encode(message.castMediaTrackSelectionChanged, writer.uint32(402).fork()).ldelim();
        }
        if (message.castMediaTrackChanged !== undefined) {
            PlayerOutput_CastMediaTracksChanged.encode(message.castMediaTrackChanged, writer.uint32(410).fork()).ldelim();
        }
        if (message.qualityChanged !== undefined) {
            PlayerOutput_QualityChanged.encode(message.qualityChanged, writer.uint32(138).fork()).ldelim();
        }
        if (message.playerError !== undefined) {
            PlayerOutput_PlayerError.encode(message.playerError, writer.uint32(130).fork()).ldelim();
        }
        if (message.wexOnEvent !== undefined) {
            Wex_PlayerOutput_Properties.encode(message.wexOnEvent, writer.uint32(146).fork()).ldelim();
        }
        if (message.latencyChanged !== undefined) {
            PlayerOutput_LatencyMetadata.encode(message.latencyChanged, writer.uint32(154).fork()).ldelim();
        }
        if (message.mediaEnded !== undefined) {
            PlayerOutput_MediaEnded.encode(message.mediaEnded, writer.uint32(162).fork()).ldelim();
        }
        if (message.adBreakStarted !== undefined) {
            PlayerOutput_AdBreakData.encode(message.adBreakStarted, writer.uint32(242).fork()).ldelim();
        }
        if (message.adBreakEnded !== undefined) {
            PlayerOutput_AdBreakData.encode(message.adBreakEnded, writer.uint32(250).fork()).ldelim();
        }
        if (message.adMetadata !== undefined) {
            PlayerOutput_AdMetadataData.encode(message.adMetadata, writer.uint32(258).fork()).ldelim();
        }
        if (message.adLoaded !== undefined) {
            PlayerOutput_AdData.encode(message.adLoaded, writer.uint32(266).fork()).ldelim();
        }
        if (message.adStarted !== undefined) {
            PlayerOutput_AdData.encode(message.adStarted, writer.uint32(274).fork()).ldelim();
        }
        if (message.adPaused !== undefined) {
            PlayerOutput_AdTimeData.encode(message.adPaused, writer.uint32(282).fork()).ldelim();
        }
        if (message.adPositionChanged !== undefined) {
            PlayerOutput_AdPositionChangedData.encode(message.adPositionChanged, writer.uint32(290).fork()).ldelim();
        }
        if (message.adFirstQuartile !== undefined) {
            PlayerOutput_AdData.encode(message.adFirstQuartile, writer.uint32(362).fork()).ldelim();
        }
        if (message.adMidpoint !== undefined) {
            PlayerOutput_AdData.encode(message.adMidpoint, writer.uint32(370).fork()).ldelim();
        }
        if (message.adThirdQuartile !== undefined) {
            PlayerOutput_AdData.encode(message.adThirdQuartile, writer.uint32(378).fork()).ldelim();
        }
        if (message.adEnded !== undefined) {
            PlayerOutput_AdData.encode(message.adEnded, writer.uint32(298).fork()).ldelim();
        }
        if (message.adSkipped !== undefined) {
            PlayerOutput_AdTimeData.encode(message.adSkipped, writer.uint32(306).fork()).ldelim();
        }
        if (message.adError !== undefined) {
            PlayerOutput_AdErrorData.encode(message.adError, writer.uint32(314).fork()).ldelim();
        }
        if (message.adResumed !== undefined) {
            PlayerOutput_AdTimeData.encode(message.adResumed, writer.uint32(338).fork()).ldelim();
        }
        if (message.adBreakSkipAvailable !== undefined) {
            PlayerOutput_AdBreakSkipAvailable.encode(message.adBreakSkipAvailable, writer.uint32(322).fork()).ldelim();
        }
        if (message.adBreakSkipUnavailable !== undefined) {
            PlayerOutput_AdBreakSkipUnavailable.encode(message.adBreakSkipUnavailable, writer.uint32(330).fork()).ldelim();
        }
        if (message.pauseAdParsed !== undefined) {
            PlayerOutput_PauseAdData.encode(message.pauseAdParsed, writer.uint32(346).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOutput_PlayerEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.watchRequested = PlayerOutput_WatchRequested.decode(reader, reader.uint32());
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.watchReceived = PlayerOutput_WatchReceived.decode(reader, reader.uint32());
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.playerReady = PlayerOutput_PlayerReady.decode(reader, reader.uint32());
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.mediaChanged = PlayerOutput_MediaChanged.decode(reader, reader.uint32());
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.currentPositionChanged = PlayerOutput_CurrentPositionChanged.decode(reader, reader.uint32());
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.seeked = PlayerOutput_Seeked.decode(reader, reader.uint32());
                    continue;
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.playbackStateChanged = PlayerOutput_PlaybackStateChanged.decode(reader, reader.uint32());
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.playerStateChanged = PlayerOutput_PlayerStateChanged.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.availableAudioTracksChanged = PlayerOutput_AvailableAudioTracksChanged.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.selectedAudioTrackChanged = PlayerOutput_SelectedAudioTrackChanged.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.availableSubtitlesTrackChanged = PlayerOutput_AvailableSubtitlesTrackChanged.decode(reader, reader.uint32());
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.selectedSubtitlesTrackChanged = PlayerOutput_SelectedSubtitlesTrackChanged.decode(reader, reader.uint32());
                    continue;
                case 50:
                    if (tag !== 402) {
                        break;
                    }
                    message.castMediaTrackSelectionChanged = PlayerOutput_CastMediaTrackSelectionChanged.decode(reader, reader.uint32());
                    continue;
                case 51:
                    if (tag !== 410) {
                        break;
                    }
                    message.castMediaTrackChanged = PlayerOutput_CastMediaTracksChanged.decode(reader, reader.uint32());
                    continue;
                case 17:
                    if (tag !== 138) {
                        break;
                    }
                    message.qualityChanged = PlayerOutput_QualityChanged.decode(reader, reader.uint32());
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.playerError = PlayerOutput_PlayerError.decode(reader, reader.uint32());
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.wexOnEvent = Wex_PlayerOutput_Properties.decode(reader, reader.uint32());
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.latencyChanged = PlayerOutput_LatencyMetadata.decode(reader, reader.uint32());
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.mediaEnded = PlayerOutput_MediaEnded.decode(reader, reader.uint32());
                    continue;
                case 30:
                    if (tag !== 242) {
                        break;
                    }
                    message.adBreakStarted = PlayerOutput_AdBreakData.decode(reader, reader.uint32());
                    continue;
                case 31:
                    if (tag !== 250) {
                        break;
                    }
                    message.adBreakEnded = PlayerOutput_AdBreakData.decode(reader, reader.uint32());
                    continue;
                case 32:
                    if (tag !== 258) {
                        break;
                    }
                    message.adMetadata = PlayerOutput_AdMetadataData.decode(reader, reader.uint32());
                    continue;
                case 33:
                    if (tag !== 266) {
                        break;
                    }
                    message.adLoaded = PlayerOutput_AdData.decode(reader, reader.uint32());
                    continue;
                case 34:
                    if (tag !== 274) {
                        break;
                    }
                    message.adStarted = PlayerOutput_AdData.decode(reader, reader.uint32());
                    continue;
                case 35:
                    if (tag !== 282) {
                        break;
                    }
                    message.adPaused = PlayerOutput_AdTimeData.decode(reader, reader.uint32());
                    continue;
                case 36:
                    if (tag !== 290) {
                        break;
                    }
                    message.adPositionChanged = PlayerOutput_AdPositionChangedData.decode(reader, reader.uint32());
                    continue;
                case 45:
                    if (tag !== 362) {
                        break;
                    }
                    message.adFirstQuartile = PlayerOutput_AdData.decode(reader, reader.uint32());
                    continue;
                case 46:
                    if (tag !== 370) {
                        break;
                    }
                    message.adMidpoint = PlayerOutput_AdData.decode(reader, reader.uint32());
                    continue;
                case 47:
                    if (tag !== 378) {
                        break;
                    }
                    message.adThirdQuartile = PlayerOutput_AdData.decode(reader, reader.uint32());
                    continue;
                case 37:
                    if (tag !== 298) {
                        break;
                    }
                    message.adEnded = PlayerOutput_AdData.decode(reader, reader.uint32());
                    continue;
                case 38:
                    if (tag !== 306) {
                        break;
                    }
                    message.adSkipped = PlayerOutput_AdTimeData.decode(reader, reader.uint32());
                    continue;
                case 39:
                    if (tag !== 314) {
                        break;
                    }
                    message.adError = PlayerOutput_AdErrorData.decode(reader, reader.uint32());
                    continue;
                case 42:
                    if (tag !== 338) {
                        break;
                    }
                    message.adResumed = PlayerOutput_AdTimeData.decode(reader, reader.uint32());
                    continue;
                case 40:
                    if (tag !== 322) {
                        break;
                    }
                    message.adBreakSkipAvailable = PlayerOutput_AdBreakSkipAvailable.decode(reader, reader.uint32());
                    continue;
                case 41:
                    if (tag !== 330) {
                        break;
                    }
                    message.adBreakSkipUnavailable = PlayerOutput_AdBreakSkipUnavailable.decode(reader, reader.uint32());
                    continue;
                case 43:
                    if (tag !== 346) {
                        break;
                    }
                    message.pauseAdParsed = PlayerOutput_PauseAdData.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            watchRequested: isSet(object.watchRequested)
                ? PlayerOutput_WatchRequested.fromJSON(object.watchRequested)
                : undefined,
            watchReceived: isSet(object.watchReceived)
                ? PlayerOutput_WatchReceived.fromJSON(object.watchReceived)
                : undefined,
            playerReady: isSet(object.playerReady) ? PlayerOutput_PlayerReady.fromJSON(object.playerReady) : undefined,
            mediaChanged: isSet(object.mediaChanged) ? PlayerOutput_MediaChanged.fromJSON(object.mediaChanged) : undefined,
            currentPositionChanged: isSet(object.currentPositionChanged)
                ? PlayerOutput_CurrentPositionChanged.fromJSON(object.currentPositionChanged)
                : undefined,
            seeked: isSet(object.seeked) ? PlayerOutput_Seeked.fromJSON(object.seeked) : undefined,
            playbackStateChanged: isSet(object.playbackStateChanged)
                ? PlayerOutput_PlaybackStateChanged.fromJSON(object.playbackStateChanged)
                : undefined,
            playerStateChanged: isSet(object.playerStateChanged)
                ? PlayerOutput_PlayerStateChanged.fromJSON(object.playerStateChanged)
                : undefined,
            availableAudioTracksChanged: isSet(object.availableAudioTracksChanged)
                ? PlayerOutput_AvailableAudioTracksChanged.fromJSON(object.availableAudioTracksChanged)
                : undefined,
            selectedAudioTrackChanged: isSet(object.selectedAudioTrackChanged)
                ? PlayerOutput_SelectedAudioTrackChanged.fromJSON(object.selectedAudioTrackChanged)
                : undefined,
            availableSubtitlesTrackChanged: isSet(object.availableSubtitlesTrackChanged)
                ? PlayerOutput_AvailableSubtitlesTrackChanged.fromJSON(object.availableSubtitlesTrackChanged)
                : undefined,
            selectedSubtitlesTrackChanged: isSet(object.selectedSubtitlesTrackChanged)
                ? PlayerOutput_SelectedSubtitlesTrackChanged.fromJSON(object.selectedSubtitlesTrackChanged)
                : undefined,
            castMediaTrackSelectionChanged: isSet(object.castMediaTrackSelectionChanged)
                ? PlayerOutput_CastMediaTrackSelectionChanged.fromJSON(object.castMediaTrackSelectionChanged)
                : undefined,
            castMediaTrackChanged: isSet(object.castMediaTrackChanged)
                ? PlayerOutput_CastMediaTracksChanged.fromJSON(object.castMediaTrackChanged)
                : undefined,
            qualityChanged: isSet(object.qualityChanged)
                ? PlayerOutput_QualityChanged.fromJSON(object.qualityChanged)
                : undefined,
            playerError: isSet(object.playerError) ? PlayerOutput_PlayerError.fromJSON(object.playerError) : undefined,
            wexOnEvent: isSet(object.wexOnEvent) ? Wex_PlayerOutput_Properties.fromJSON(object.wexOnEvent) : undefined,
            latencyChanged: isSet(object.latencyChanged)
                ? PlayerOutput_LatencyMetadata.fromJSON(object.latencyChanged)
                : undefined,
            mediaEnded: isSet(object.mediaEnded) ? PlayerOutput_MediaEnded.fromJSON(object.mediaEnded) : undefined,
            adBreakStarted: isSet(object.adBreakStarted)
                ? PlayerOutput_AdBreakData.fromJSON(object.adBreakStarted)
                : undefined,
            adBreakEnded: isSet(object.adBreakEnded) ? PlayerOutput_AdBreakData.fromJSON(object.adBreakEnded) : undefined,
            adMetadata: isSet(object.adMetadata) ? PlayerOutput_AdMetadataData.fromJSON(object.adMetadata) : undefined,
            adLoaded: isSet(object.adLoaded) ? PlayerOutput_AdData.fromJSON(object.adLoaded) : undefined,
            adStarted: isSet(object.adStarted) ? PlayerOutput_AdData.fromJSON(object.adStarted) : undefined,
            adPaused: isSet(object.adPaused) ? PlayerOutput_AdTimeData.fromJSON(object.adPaused) : undefined,
            adPositionChanged: isSet(object.adPositionChanged)
                ? PlayerOutput_AdPositionChangedData.fromJSON(object.adPositionChanged)
                : undefined,
            adFirstQuartile: isSet(object.adFirstQuartile) ? PlayerOutput_AdData.fromJSON(object.adFirstQuartile) : undefined,
            adMidpoint: isSet(object.adMidpoint) ? PlayerOutput_AdData.fromJSON(object.adMidpoint) : undefined,
            adThirdQuartile: isSet(object.adThirdQuartile) ? PlayerOutput_AdData.fromJSON(object.adThirdQuartile) : undefined,
            adEnded: isSet(object.adEnded) ? PlayerOutput_AdData.fromJSON(object.adEnded) : undefined,
            adSkipped: isSet(object.adSkipped) ? PlayerOutput_AdTimeData.fromJSON(object.adSkipped) : undefined,
            adError: isSet(object.adError) ? PlayerOutput_AdErrorData.fromJSON(object.adError) : undefined,
            adResumed: isSet(object.adResumed) ? PlayerOutput_AdTimeData.fromJSON(object.adResumed) : undefined,
            adBreakSkipAvailable: isSet(object.adBreakSkipAvailable)
                ? PlayerOutput_AdBreakSkipAvailable.fromJSON(object.adBreakSkipAvailable)
                : undefined,
            adBreakSkipUnavailable: isSet(object.adBreakSkipUnavailable)
                ? PlayerOutput_AdBreakSkipUnavailable.fromJSON(object.adBreakSkipUnavailable)
                : undefined,
            pauseAdParsed: isSet(object.pauseAdParsed) ? PlayerOutput_PauseAdData.fromJSON(object.pauseAdParsed) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.watchRequested !== undefined) {
            obj.watchRequested = PlayerOutput_WatchRequested.toJSON(message.watchRequested);
        }
        if (message.watchReceived !== undefined) {
            obj.watchReceived = PlayerOutput_WatchReceived.toJSON(message.watchReceived);
        }
        if (message.playerReady !== undefined) {
            obj.playerReady = PlayerOutput_PlayerReady.toJSON(message.playerReady);
        }
        if (message.mediaChanged !== undefined) {
            obj.mediaChanged = PlayerOutput_MediaChanged.toJSON(message.mediaChanged);
        }
        if (message.currentPositionChanged !== undefined) {
            obj.currentPositionChanged = PlayerOutput_CurrentPositionChanged.toJSON(message.currentPositionChanged);
        }
        if (message.seeked !== undefined) {
            obj.seeked = PlayerOutput_Seeked.toJSON(message.seeked);
        }
        if (message.playbackStateChanged !== undefined) {
            obj.playbackStateChanged = PlayerOutput_PlaybackStateChanged.toJSON(message.playbackStateChanged);
        }
        if (message.playerStateChanged !== undefined) {
            obj.playerStateChanged = PlayerOutput_PlayerStateChanged.toJSON(message.playerStateChanged);
        }
        if (message.availableAudioTracksChanged !== undefined) {
            obj.availableAudioTracksChanged = PlayerOutput_AvailableAudioTracksChanged.toJSON(message.availableAudioTracksChanged);
        }
        if (message.selectedAudioTrackChanged !== undefined) {
            obj.selectedAudioTrackChanged = PlayerOutput_SelectedAudioTrackChanged.toJSON(message.selectedAudioTrackChanged);
        }
        if (message.availableSubtitlesTrackChanged !== undefined) {
            obj.availableSubtitlesTrackChanged = PlayerOutput_AvailableSubtitlesTrackChanged.toJSON(message.availableSubtitlesTrackChanged);
        }
        if (message.selectedSubtitlesTrackChanged !== undefined) {
            obj.selectedSubtitlesTrackChanged = PlayerOutput_SelectedSubtitlesTrackChanged.toJSON(message.selectedSubtitlesTrackChanged);
        }
        if (message.castMediaTrackSelectionChanged !== undefined) {
            obj.castMediaTrackSelectionChanged = PlayerOutput_CastMediaTrackSelectionChanged.toJSON(message.castMediaTrackSelectionChanged);
        }
        if (message.castMediaTrackChanged !== undefined) {
            obj.castMediaTrackChanged = PlayerOutput_CastMediaTracksChanged.toJSON(message.castMediaTrackChanged);
        }
        if (message.qualityChanged !== undefined) {
            obj.qualityChanged = PlayerOutput_QualityChanged.toJSON(message.qualityChanged);
        }
        if (message.playerError !== undefined) {
            obj.playerError = PlayerOutput_PlayerError.toJSON(message.playerError);
        }
        if (message.wexOnEvent !== undefined) {
            obj.wexOnEvent = Wex_PlayerOutput_Properties.toJSON(message.wexOnEvent);
        }
        if (message.latencyChanged !== undefined) {
            obj.latencyChanged = PlayerOutput_LatencyMetadata.toJSON(message.latencyChanged);
        }
        if (message.mediaEnded !== undefined) {
            obj.mediaEnded = PlayerOutput_MediaEnded.toJSON(message.mediaEnded);
        }
        if (message.adBreakStarted !== undefined) {
            obj.adBreakStarted = PlayerOutput_AdBreakData.toJSON(message.adBreakStarted);
        }
        if (message.adBreakEnded !== undefined) {
            obj.adBreakEnded = PlayerOutput_AdBreakData.toJSON(message.adBreakEnded);
        }
        if (message.adMetadata !== undefined) {
            obj.adMetadata = PlayerOutput_AdMetadataData.toJSON(message.adMetadata);
        }
        if (message.adLoaded !== undefined) {
            obj.adLoaded = PlayerOutput_AdData.toJSON(message.adLoaded);
        }
        if (message.adStarted !== undefined) {
            obj.adStarted = PlayerOutput_AdData.toJSON(message.adStarted);
        }
        if (message.adPaused !== undefined) {
            obj.adPaused = PlayerOutput_AdTimeData.toJSON(message.adPaused);
        }
        if (message.adPositionChanged !== undefined) {
            obj.adPositionChanged = PlayerOutput_AdPositionChangedData.toJSON(message.adPositionChanged);
        }
        if (message.adFirstQuartile !== undefined) {
            obj.adFirstQuartile = PlayerOutput_AdData.toJSON(message.adFirstQuartile);
        }
        if (message.adMidpoint !== undefined) {
            obj.adMidpoint = PlayerOutput_AdData.toJSON(message.adMidpoint);
        }
        if (message.adThirdQuartile !== undefined) {
            obj.adThirdQuartile = PlayerOutput_AdData.toJSON(message.adThirdQuartile);
        }
        if (message.adEnded !== undefined) {
            obj.adEnded = PlayerOutput_AdData.toJSON(message.adEnded);
        }
        if (message.adSkipped !== undefined) {
            obj.adSkipped = PlayerOutput_AdTimeData.toJSON(message.adSkipped);
        }
        if (message.adError !== undefined) {
            obj.adError = PlayerOutput_AdErrorData.toJSON(message.adError);
        }
        if (message.adResumed !== undefined) {
            obj.adResumed = PlayerOutput_AdTimeData.toJSON(message.adResumed);
        }
        if (message.adBreakSkipAvailable !== undefined) {
            obj.adBreakSkipAvailable = PlayerOutput_AdBreakSkipAvailable.toJSON(message.adBreakSkipAvailable);
        }
        if (message.adBreakSkipUnavailable !== undefined) {
            obj.adBreakSkipUnavailable = PlayerOutput_AdBreakSkipUnavailable.toJSON(message.adBreakSkipUnavailable);
        }
        if (message.pauseAdParsed !== undefined) {
            obj.pauseAdParsed = PlayerOutput_PauseAdData.toJSON(message.pauseAdParsed);
        }
        return obj;
    },
    create(base) {
        return Output_PlayerEvent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOutput_PlayerEvent();
        message.watchRequested = (object.watchRequested !== undefined && object.watchRequested !== null)
            ? PlayerOutput_WatchRequested.fromPartial(object.watchRequested)
            : undefined;
        message.watchReceived = (object.watchReceived !== undefined && object.watchReceived !== null)
            ? PlayerOutput_WatchReceived.fromPartial(object.watchReceived)
            : undefined;
        message.playerReady = (object.playerReady !== undefined && object.playerReady !== null)
            ? PlayerOutput_PlayerReady.fromPartial(object.playerReady)
            : undefined;
        message.mediaChanged = (object.mediaChanged !== undefined && object.mediaChanged !== null)
            ? PlayerOutput_MediaChanged.fromPartial(object.mediaChanged)
            : undefined;
        message.currentPositionChanged =
            (object.currentPositionChanged !== undefined && object.currentPositionChanged !== null)
                ? PlayerOutput_CurrentPositionChanged.fromPartial(object.currentPositionChanged)
                : undefined;
        message.seeked = (object.seeked !== undefined && object.seeked !== null)
            ? PlayerOutput_Seeked.fromPartial(object.seeked)
            : undefined;
        message.playbackStateChanged = (object.playbackStateChanged !== undefined && object.playbackStateChanged !== null)
            ? PlayerOutput_PlaybackStateChanged.fromPartial(object.playbackStateChanged)
            : undefined;
        message.playerStateChanged = (object.playerStateChanged !== undefined && object.playerStateChanged !== null)
            ? PlayerOutput_PlayerStateChanged.fromPartial(object.playerStateChanged)
            : undefined;
        message.availableAudioTracksChanged =
            (object.availableAudioTracksChanged !== undefined && object.availableAudioTracksChanged !== null)
                ? PlayerOutput_AvailableAudioTracksChanged.fromPartial(object.availableAudioTracksChanged)
                : undefined;
        message.selectedAudioTrackChanged =
            (object.selectedAudioTrackChanged !== undefined && object.selectedAudioTrackChanged !== null)
                ? PlayerOutput_SelectedAudioTrackChanged.fromPartial(object.selectedAudioTrackChanged)
                : undefined;
        message.availableSubtitlesTrackChanged =
            (object.availableSubtitlesTrackChanged !== undefined && object.availableSubtitlesTrackChanged !== null)
                ? PlayerOutput_AvailableSubtitlesTrackChanged.fromPartial(object.availableSubtitlesTrackChanged)
                : undefined;
        message.selectedSubtitlesTrackChanged =
            (object.selectedSubtitlesTrackChanged !== undefined && object.selectedSubtitlesTrackChanged !== null)
                ? PlayerOutput_SelectedSubtitlesTrackChanged.fromPartial(object.selectedSubtitlesTrackChanged)
                : undefined;
        message.castMediaTrackSelectionChanged =
            (object.castMediaTrackSelectionChanged !== undefined && object.castMediaTrackSelectionChanged !== null)
                ? PlayerOutput_CastMediaTrackSelectionChanged.fromPartial(object.castMediaTrackSelectionChanged)
                : undefined;
        message.castMediaTrackChanged =
            (object.castMediaTrackChanged !== undefined && object.castMediaTrackChanged !== null)
                ? PlayerOutput_CastMediaTracksChanged.fromPartial(object.castMediaTrackChanged)
                : undefined;
        message.qualityChanged = (object.qualityChanged !== undefined && object.qualityChanged !== null)
            ? PlayerOutput_QualityChanged.fromPartial(object.qualityChanged)
            : undefined;
        message.playerError = (object.playerError !== undefined && object.playerError !== null)
            ? PlayerOutput_PlayerError.fromPartial(object.playerError)
            : undefined;
        message.wexOnEvent = (object.wexOnEvent !== undefined && object.wexOnEvent !== null)
            ? Wex_PlayerOutput_Properties.fromPartial(object.wexOnEvent)
            : undefined;
        message.latencyChanged = (object.latencyChanged !== undefined && object.latencyChanged !== null)
            ? PlayerOutput_LatencyMetadata.fromPartial(object.latencyChanged)
            : undefined;
        message.mediaEnded = (object.mediaEnded !== undefined && object.mediaEnded !== null)
            ? PlayerOutput_MediaEnded.fromPartial(object.mediaEnded)
            : undefined;
        message.adBreakStarted = (object.adBreakStarted !== undefined && object.adBreakStarted !== null)
            ? PlayerOutput_AdBreakData.fromPartial(object.adBreakStarted)
            : undefined;
        message.adBreakEnded = (object.adBreakEnded !== undefined && object.adBreakEnded !== null)
            ? PlayerOutput_AdBreakData.fromPartial(object.adBreakEnded)
            : undefined;
        message.adMetadata = (object.adMetadata !== undefined && object.adMetadata !== null)
            ? PlayerOutput_AdMetadataData.fromPartial(object.adMetadata)
            : undefined;
        message.adLoaded = (object.adLoaded !== undefined && object.adLoaded !== null)
            ? PlayerOutput_AdData.fromPartial(object.adLoaded)
            : undefined;
        message.adStarted = (object.adStarted !== undefined && object.adStarted !== null)
            ? PlayerOutput_AdData.fromPartial(object.adStarted)
            : undefined;
        message.adPaused = (object.adPaused !== undefined && object.adPaused !== null)
            ? PlayerOutput_AdTimeData.fromPartial(object.adPaused)
            : undefined;
        message.adPositionChanged = (object.adPositionChanged !== undefined && object.adPositionChanged !== null)
            ? PlayerOutput_AdPositionChangedData.fromPartial(object.adPositionChanged)
            : undefined;
        message.adFirstQuartile = (object.adFirstQuartile !== undefined && object.adFirstQuartile !== null)
            ? PlayerOutput_AdData.fromPartial(object.adFirstQuartile)
            : undefined;
        message.adMidpoint = (object.adMidpoint !== undefined && object.adMidpoint !== null)
            ? PlayerOutput_AdData.fromPartial(object.adMidpoint)
            : undefined;
        message.adThirdQuartile = (object.adThirdQuartile !== undefined && object.adThirdQuartile !== null)
            ? PlayerOutput_AdData.fromPartial(object.adThirdQuartile)
            : undefined;
        message.adEnded = (object.adEnded !== undefined && object.adEnded !== null)
            ? PlayerOutput_AdData.fromPartial(object.adEnded)
            : undefined;
        message.adSkipped = (object.adSkipped !== undefined && object.adSkipped !== null)
            ? PlayerOutput_AdTimeData.fromPartial(object.adSkipped)
            : undefined;
        message.adError = (object.adError !== undefined && object.adError !== null)
            ? PlayerOutput_AdErrorData.fromPartial(object.adError)
            : undefined;
        message.adResumed = (object.adResumed !== undefined && object.adResumed !== null)
            ? PlayerOutput_AdTimeData.fromPartial(object.adResumed)
            : undefined;
        message.adBreakSkipAvailable = (object.adBreakSkipAvailable !== undefined && object.adBreakSkipAvailable !== null)
            ? PlayerOutput_AdBreakSkipAvailable.fromPartial(object.adBreakSkipAvailable)
            : undefined;
        message.adBreakSkipUnavailable =
            (object.adBreakSkipUnavailable !== undefined && object.adBreakSkipUnavailable !== null)
                ? PlayerOutput_AdBreakSkipUnavailable.fromPartial(object.adBreakSkipUnavailable)
                : undefined;
        message.pauseAdParsed = (object.pauseAdParsed !== undefined && object.pauseAdParsed !== null)
            ? PlayerOutput_PauseAdData.fromPartial(object.pauseAdParsed)
            : undefined;
        return message;
    },
};
function createBaseOutput_ActionResult() {
    return {
        id: "",
        success: false,
        error: undefined,
        mediaChanged: undefined,
        availableAudioTracks: undefined,
        selectedAudioTrack: undefined,
        availableSubtitlesTracks: undefined,
        selectedSubtitlesTrack: undefined,
        properties: undefined,
        wexProperties: undefined,
        seekResult: undefined,
        thumbnailData: undefined,
    };
}
export const Output_ActionResult = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.success !== false) {
            writer.uint32(16).bool(message.success);
        }
        if (message.error !== undefined) {
            writer.uint32(26).string(message.error);
        }
        if (message.mediaChanged !== undefined) {
            PlayerOutput_MediaChanged.encode(message.mediaChanged, writer.uint32(34).fork()).ldelim();
        }
        if (message.availableAudioTracks !== undefined) {
            PlayerOutput_AvailableAudioTracks.encode(message.availableAudioTracks, writer.uint32(74).fork()).ldelim();
        }
        if (message.selectedAudioTrack !== undefined) {
            PlayerOutput_SelectedAudioTrack.encode(message.selectedAudioTrack, writer.uint32(90).fork()).ldelim();
        }
        if (message.availableSubtitlesTracks !== undefined) {
            PlayerOutput_AvailableSubtitlesTracks.encode(message.availableSubtitlesTracks, writer.uint32(82).fork()).ldelim();
        }
        if (message.selectedSubtitlesTrack !== undefined) {
            PlayerOutput_SelectedSubtitlesTrack.encode(message.selectedSubtitlesTrack, writer.uint32(98).fork()).ldelim();
        }
        if (message.properties !== undefined) {
            PlayerOutput_Properties.encode(message.properties, writer.uint32(106).fork()).ldelim();
        }
        if (message.wexProperties !== undefined) {
            Wex_PlayerOutput_Properties.encode(message.wexProperties, writer.uint32(114).fork()).ldelim();
        }
        if (message.seekResult !== undefined) {
            PlayerOutput_SeekResult.encode(message.seekResult, writer.uint32(122).fork()).ldelim();
        }
        if (message.thumbnailData !== undefined) {
            PlayerOutput_ThumbnailData.encode(message.thumbnailData, writer.uint32(130).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOutput_ActionResult();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.success = reader.bool();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.error = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.mediaChanged = PlayerOutput_MediaChanged.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.availableAudioTracks = PlayerOutput_AvailableAudioTracks.decode(reader, reader.uint32());
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.selectedAudioTrack = PlayerOutput_SelectedAudioTrack.decode(reader, reader.uint32());
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.availableSubtitlesTracks = PlayerOutput_AvailableSubtitlesTracks.decode(reader, reader.uint32());
                    continue;
                case 12:
                    if (tag !== 98) {
                        break;
                    }
                    message.selectedSubtitlesTrack = PlayerOutput_SelectedSubtitlesTrack.decode(reader, reader.uint32());
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.properties = PlayerOutput_Properties.decode(reader, reader.uint32());
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.wexProperties = Wex_PlayerOutput_Properties.decode(reader, reader.uint32());
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.seekResult = PlayerOutput_SeekResult.decode(reader, reader.uint32());
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.thumbnailData = PlayerOutput_ThumbnailData.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
            error: isSet(object.error) ? globalThis.String(object.error) : undefined,
            mediaChanged: isSet(object.mediaChanged) ? PlayerOutput_MediaChanged.fromJSON(object.mediaChanged) : undefined,
            availableAudioTracks: isSet(object.availableAudioTracks)
                ? PlayerOutput_AvailableAudioTracks.fromJSON(object.availableAudioTracks)
                : undefined,
            selectedAudioTrack: isSet(object.selectedAudioTrack)
                ? PlayerOutput_SelectedAudioTrack.fromJSON(object.selectedAudioTrack)
                : undefined,
            availableSubtitlesTracks: isSet(object.availableSubtitlesTracks)
                ? PlayerOutput_AvailableSubtitlesTracks.fromJSON(object.availableSubtitlesTracks)
                : undefined,
            selectedSubtitlesTrack: isSet(object.selectedSubtitlesTrack)
                ? PlayerOutput_SelectedSubtitlesTrack.fromJSON(object.selectedSubtitlesTrack)
                : undefined,
            properties: isSet(object.properties) ? PlayerOutput_Properties.fromJSON(object.properties) : undefined,
            wexProperties: isSet(object.wexProperties)
                ? Wex_PlayerOutput_Properties.fromJSON(object.wexProperties)
                : undefined,
            seekResult: isSet(object.seekResult) ? PlayerOutput_SeekResult.fromJSON(object.seekResult) : undefined,
            thumbnailData: isSet(object.thumbnailData)
                ? PlayerOutput_ThumbnailData.fromJSON(object.thumbnailData)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.success !== false) {
            obj.success = message.success;
        }
        if (message.error !== undefined) {
            obj.error = message.error;
        }
        if (message.mediaChanged !== undefined) {
            obj.mediaChanged = PlayerOutput_MediaChanged.toJSON(message.mediaChanged);
        }
        if (message.availableAudioTracks !== undefined) {
            obj.availableAudioTracks = PlayerOutput_AvailableAudioTracks.toJSON(message.availableAudioTracks);
        }
        if (message.selectedAudioTrack !== undefined) {
            obj.selectedAudioTrack = PlayerOutput_SelectedAudioTrack.toJSON(message.selectedAudioTrack);
        }
        if (message.availableSubtitlesTracks !== undefined) {
            obj.availableSubtitlesTracks = PlayerOutput_AvailableSubtitlesTracks.toJSON(message.availableSubtitlesTracks);
        }
        if (message.selectedSubtitlesTrack !== undefined) {
            obj.selectedSubtitlesTrack = PlayerOutput_SelectedSubtitlesTrack.toJSON(message.selectedSubtitlesTrack);
        }
        if (message.properties !== undefined) {
            obj.properties = PlayerOutput_Properties.toJSON(message.properties);
        }
        if (message.wexProperties !== undefined) {
            obj.wexProperties = Wex_PlayerOutput_Properties.toJSON(message.wexProperties);
        }
        if (message.seekResult !== undefined) {
            obj.seekResult = PlayerOutput_SeekResult.toJSON(message.seekResult);
        }
        if (message.thumbnailData !== undefined) {
            obj.thumbnailData = PlayerOutput_ThumbnailData.toJSON(message.thumbnailData);
        }
        return obj;
    },
    create(base) {
        return Output_ActionResult.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOutput_ActionResult();
        message.id = object.id ?? "";
        message.success = object.success ?? false;
        message.error = object.error ?? undefined;
        message.mediaChanged = (object.mediaChanged !== undefined && object.mediaChanged !== null)
            ? PlayerOutput_MediaChanged.fromPartial(object.mediaChanged)
            : undefined;
        message.availableAudioTracks = (object.availableAudioTracks !== undefined && object.availableAudioTracks !== null)
            ? PlayerOutput_AvailableAudioTracks.fromPartial(object.availableAudioTracks)
            : undefined;
        message.selectedAudioTrack = (object.selectedAudioTrack !== undefined && object.selectedAudioTrack !== null)
            ? PlayerOutput_SelectedAudioTrack.fromPartial(object.selectedAudioTrack)
            : undefined;
        message.availableSubtitlesTracks =
            (object.availableSubtitlesTracks !== undefined && object.availableSubtitlesTracks !== null)
                ? PlayerOutput_AvailableSubtitlesTracks.fromPartial(object.availableSubtitlesTracks)
                : undefined;
        message.selectedSubtitlesTrack =
            (object.selectedSubtitlesTrack !== undefined && object.selectedSubtitlesTrack !== null)
                ? PlayerOutput_SelectedSubtitlesTrack.fromPartial(object.selectedSubtitlesTrack)
                : undefined;
        message.properties = (object.properties !== undefined && object.properties !== null)
            ? PlayerOutput_Properties.fromPartial(object.properties)
            : undefined;
        message.wexProperties = (object.wexProperties !== undefined && object.wexProperties !== null)
            ? Wex_PlayerOutput_Properties.fromPartial(object.wexProperties)
            : undefined;
        message.seekResult = (object.seekResult !== undefined && object.seekResult !== null)
            ? PlayerOutput_SeekResult.fromPartial(object.seekResult)
            : undefined;
        message.thumbnailData = (object.thumbnailData !== undefined && object.thumbnailData !== null)
            ? PlayerOutput_ThumbnailData.fromPartial(object.thumbnailData)
            : undefined;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
